import { WorkItem } from '../../types/Work/WorkItem'

export type AssignRow = {
	id: string
	kind: 'workItem' | 'loading' | 'error'
	workItem: WorkItem
	layer: number
}

export function getVisibleAssignRows(
	workItems: WorkItem[],
	childrenById: Map<number, WorkItem[]>,
	expandedIds: Set<number>,
	loadingIds: Set<number>,
	failedIds: Set<number>,
): AssignRow[] {
	const rows: AssignRow[] = []
	const visit = (workItem: WorkItem, layer: number, parentRowId: string, ancestors: Set<number>) => {
		const id = `${parentRowId}/wi-${workItem.id}`
		rows.push({ id, kind: 'workItem', workItem, layer })
		if (!expandedIds.has(workItem.id) || ancestors.has(workItem.id)) return
		const children = childrenById.get(workItem.id)
		if (children) {
			const path = new Set(ancestors).add(workItem.id)
			children.forEach((child) => visit(child, layer + 1, id, path))
		} else if (loadingIds.has(workItem.id)) {
			rows.push({ id: `${id}/loading`, kind: 'loading', workItem, layer })
		} else if (failedIds.has(workItem.id)) {
			rows.push({ id: `${id}/error`, kind: 'error', workItem, layer })
		}
	}
	workItems.forEach((workItem) => visit(workItem, 1, '', new Set()))
	return rows
}

export function buildLoadedDescendantMap(
	workItems: WorkItem[],
	childrenById: Map<number, WorkItem[]>,
	map = new Map<number, number[]>(),
): Map<number, number[]> {
	const visit = (node: WorkItem, ancestors: Set<number>): number[] => {
		const all: number[] = []
		if (!ancestors.has(node.id)) {
			const path = new Set(ancestors).add(node.id)
			for (const child of childrenById.get(node.id) ?? []) {
				all.push(child.id, ...visit(child, path))
			}
		}
		map.set(node.id, all)
		return all
	}
	workItems.forEach((workItem) => visit(workItem, new Set()))
	return map
}
